<template>
  <div>
    <v-tooltip top v-if="disabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs" class="fit">
          <button-base disabled> Preview As Carrier</button-base>
        </div>
      </template>
      <span>Save the settings to enable the preview mode</span>
    </v-tooltip>
    <button-base v-else class="primary" @click="jumpToLunaPreview()" :loading="loading">
      Preview As Carrier
    </button-base>
    <p class="mt-2">
      This will open the carrier view in preview mode. You will not be able to finalize an
      appointment through this preview.
      <br />
      <strong>Note:</strong> Do not share this direct preview link with carriers. Please send
      carriers directly to the carrier portal at
      <a href="https://www.opendock.com/" target="_blank" rel="noopener">opendock.com</a> to
      schedule appointments with your facility.
    </p>
  </div>
</template>

<script>
import config from '@/config/config';

export default {
  name: 'PreviewAsCarrierButton',
  props: {
    /**
     * Warehouse Object
     */
    warehouse: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async jumpToLunaPreview() {
      this.loading = true;
      try {
        const res = await axios.post('/carrier/preview', {});
        window.open(
          `${config.luna_url}/auth?token=${res.data.access_token}&warehouseId=${this.warehouse.id}`,
          '_blank'
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.fit {
  width: fit-content;
}
</style>
